import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import {
  rootReducerKey,
  SERVICE_PROJECT_COMMON_REDUCER_TOKEN,
  serviceProjectCommonReducerProvider
} from './common.reducer';
import { EffectsModule } from '@ngrx/effects';
import { ServiceProjectCommonEffects } from './common.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(rootReducerKey, SERVICE_PROJECT_COMMON_REDUCER_TOKEN),
    EffectsModule.forFeature([ServiceProjectCommonEffects])
  ],
  providers: [
    serviceProjectCommonReducerProvider
  ]
})
export class ServiceProjectCommonStoreModule { }
